import React from "react";
import { Alert } from "react-bootstrap";

const ViewportAlert = ({ bsStyle, children, onDismiss }) => (
  <div
    role="status"
    aria-live={bsStyle === "danger" ? "assertive" : "polite"}
    style={{
      position: "fixed",
      top: 15,
      left: 15,
      right: 15,
      zIndex: 10050,
      maxWidth: 760,
      margin: "0 auto",
      pointerEvents: "none"
    }}
  >
    <Alert
      bsStyle={bsStyle}
      style={{
        margin: 0,
        boxShadow: "0 5px 18px rgba(0, 0, 0, 0.2)",
        pointerEvents: "auto"
      }}
    >
      {onDismiss && (
        <button type="button" className="close" onClick={onDismiss}>
          <span aria-hidden="true">&times;</span>
          <span className="sr-only">Zamknij komunikat</span>
        </button>
      )}
      {children}
    </Alert>
  </div>
);

export default ViewportAlert;



// WEBPACK FOOTER //
// ./src/components/ViewportAlert/ViewportAlert.jsx